import React from 'react';

import Button from '@react/react-spectrum/Button';
import Heading from '@react/react-spectrum/Heading';
import Link from '@react/react-spectrum/Link';

import Hammer from '@react/react-spectrum/Icon/Hammer';

import './MarketoSidebar.scss';

const Sidebar = ({ instance, openPanel }) => {
  return (
    <div className="marketo-sidebar">
      <section>
        <Heading size={2}>{instance.url}</Heading>
        <Heading variant="subtitle3">Marketo</Heading>
      </section>

      <section>
        <Heading variant="subtitle1">Actions</Heading>
        <div>
          <Button
            label="Apply configuration"
            icon={<Hammer />}
            onClick={() => openPanel(instance)}
            quiet
          />
        </div>
      </section>

      <section>
        <Heading variant="subtitle1">Properties</Heading>
        <Heading variant="subtitle3">URL</Heading>
        <div style={{ overflowWrap: 'break-word' }}>
          <Link href={instance.url} target="_blank">
            {instance.url}
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Sidebar;
